import React from 'react';

const plans = [
  {
    name: 'Impulso Temporada',
    planId: 'Impulso',
    price: '$25.000',
    period: '2 meses',
    description: 'Para no quedar invisible',
    color: '#10b981',
    badge: null,
    features: [
      'Mejor posición que publicaciones estándar',
      'Etiqueta "Destacado" durante la campaña',
      'Inclusión en listados de temporada',
      'Soporte básico',
      'Comisión estándar: 6,5% + IVA',
    ],
    cta: 'Elegir Impulso',
    highlight: false,
  },
  {
    name: 'Crecimiento Temporada',
    planId: 'Crecimiento',
    price: '$40.000',
    period: '2 meses',
    description: 'Más exposición + mejor margen',
    color: '#f59e0b',
    badge: 'Más elegido',
    features: [
      'Todo lo del Plan Impulso',
      'Alta prioridad en búsquedas',
      'Optimización de ficha (copy + orden visual)',
      'Difusión en Instagram Alohar',
      'Inclusión en selecciones especiales',
      'Beneficio comercial: comisión 5,5% + IVA',
    ],
    cta: 'Elegir Crecimiento',
    highlight: true,
  },
  {
    name: 'Protagonista Temporada',
    planId: 'Protagonista',
    price: '$65.000',
    period: '2 meses',
    description: 'Estar al frente cuando todos compiten',
    color: '#3b82f6',
    badge: null,
    features: [
      'Todo lo del Plan Crecimiento',
      'Máxima prioridad en búsquedas',
      'Publicaciones dedicadas en redes',
      'Historias + reels de temporada',
      'Inclusión en campañas de email',
      'Derivación directa de consultas',
      'Asesoramiento express (precio + fechas clave)',
      'Beneficio comercial: comisión 4,5% + IVA',
    ],
    cta: 'Elegir Protagonista',
    highlight: false,
  },
];

const CampanaPricing = () => {
  const getWhatsAppUrl = (planName) => {
    const baseUrl = 'https://api.whatsapp.com/send?phone=5492233018749&text=';
    const message = encodeURIComponent(`¡Hola Alohar! Quisiera que me contacten por el plan ${planName}.`);
    return `${baseUrl}${message}`;
  };

  const getCtaUrl = (planId) => {
    if (planId === 'Impulso') {
      return 'https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=b1ba949667304d6c993617310b669d49';
    }
    if (planId === 'Crecimiento') {
      return 'https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=351de47775524b80a0ae3b2a6db2099c';
    }
    if (planId === 'Protagonista') {
      return 'https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=85f286dccdf849b5bf8c3fc3231c51a1';
    }
    return getWhatsAppUrl(planId);
  };

  return (
    <section id="planes" className="campana-pricing">
      <div className="campana-pricing__container">
        <div className="campana-pricing__header">
          <h2 className="campana-pricing__title">Planes de Campaña</h2>
          <p className="campana-pricing__subtitle">Carnaval + Semana Santa</p>
        </div>

        <div className="campana-pricing__plans">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`campana-pricing__plan ${plan.highlight ? 'campana-pricing__plan--highlight' : ''}`}
            >
              {plan.badge && (
                <div className="campana-pricing__badge">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  {plan.badge}
                </div>
              )}

              <div className="campana-pricing__plan-header">
                <div className="campana-pricing__plan-dot" style={{ backgroundColor: plan.color }} />
                <h3 className="campana-pricing__plan-name">{plan.name}</h3>
              </div>

              <div className="campana-pricing__plan-price">
                <span className="campana-pricing__plan-amount">{plan.price}</span>
                <span className="campana-pricing__plan-period"> / {plan.period}</span>
              </div>

              <p className="campana-pricing__plan-description">{plan.description}</p>

              <ul className="campana-pricing__features">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="campana-pricing__feature">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="campana-pricing__check"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <a
                href={getCtaUrl(plan.planId)}
                target="_blank"
                rel="noopener noreferrer"
                className="campana-pricing__cta"
              >
                {plan.cta}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CampanaPricing;
